// Import model
import { Menu } from '../models/Menu';

// Import base class serializer
import { MenuItemSerializer } from './MenuItemSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Menu - handles JSON serialization and deserialization with type validation
 */
export class MenuSerializer {
  /**
   * Deserializes a JSON string into a Menu instance
   */
  static deserialize(json: string): Menu {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Menu instance
   */
  static fromObject(obj: any): Menu {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Menu');
    }


    const instance: Menu = {
      icon: obj['Icon'] as string | undefined,
      t: obj['_t'] as string,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      collapsible: obj['Collapsible'] as boolean | undefined,
      items: obj['Items'] ? (obj['Items'] as any[]).map((item: any) =>
        MenuItemSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Menu instances
   */
  static deserializeArray(json: string): Menu[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Menu instance to a JSON string
   */
  static serialize(instance: Menu): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Menu instance to a plain object
   */
  static toObject(instance: Menu): any {
    return {
      'Icon': instance.icon,
      '_t': instance.t,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      'Collapsible': instance.collapsible,
      'Items': instance.items?.map((item: any) =>
        MenuItemSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of Menu instances to a JSON string
   */
  static serializeArray(instances: Menu[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
